import React, { useState, useEffect, useRef } from "react";
//import emailjs from "emailjs-com";
import { Grid, Tooltip, IconButton, Typography } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import 'rc-datepicker/lib/style.css';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import TextEditor from "../../biztran_controls/TextEditor";
import 'moment/locale/it.js';
import CloseIcon from "@material-ui/icons/Close";
import { Email } from "@material-ui/icons";


let Attchments = [], FileExt = "", Base64String = null;

const SendEmail = (props) => {
    const [DtlsData, setDtlsData] = useState();
    const [MobileNo, setMobileNo] = useState('');
    const [Message, setMessage] = useState('');
    const [Subject, setSubject] = useState('Testing');
    const [FromEmail, setFromMail] = useState(sessionStorage.Email);
    // const [FromEmail, setFromMail] = useState("akhilbabubiztransolutions@gmail.com");
    const [ToEmail, setToEmail] = useState(props.EmailData);        // 4/feb change
    // const [ToEmail, setToEmail] = useState('');
    //(["namrata.j@biztransolutions.com"]); //, "george.v@biztransolutions.com"]);
    //const [SenderMail, setSenderMail] = useState('');
    const [EmailOption, setEmailOptions] = useState([]);
    // debugger;
    const [SenderPassword, setSenderPassword] = useState(sessionStorage.EmailPassword);
    // const [SenderPassword, setSenderPassword] = useState('Akhil@143');
    const [EMailBody, setEMailBody] = useState('Hello');
    const [FileMainState, setFileMainState] = useState("initial");
    const [SelectedFile, setSelectedFile] = useState(null);
    const [FileUploaded, setFileUploaded] = useState(0);
    const [TemplateID, setTemplateID] = useState("");
    const [ReqLabelFName, setReqLabelFName] = useState("none");
    const [ReqLabelFType, setReqLabelFType] = useState("none");
    const [FileName, setFileName] = useState("");
    const [FileAttName, setFileAttName] = useState("");
    const [AttachmentPath, setAttachmentPath] = useState([]);
    const [TemplateNamecmb, setTemplateNamecmb] = useState([]);
    const [FileType, setFileType] = useState("");
    const [response, fetchData] = UseFetchData();
    const [responseUpload, fetchUploadData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [responseTempData, fetchTempData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    const [AccName, setAccName] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [responseEmail, fetchEmailData] = UseFetchData();
    const [EmailCmb, setEmailCmb] = useState([]);
    const [ToEmailData, setToEmailData] = useState([]);





    const validationSchema = Yup.object({
    });


    function sendEmail(e) {
        e.preventDefault();
        var bodyFormData = new FormData();
        bodyFormData.append("FromEmail", FromEmail);
        // bodyFormData.append("ToEmail", ToEmail);
        for (var i = 0; i < ToEmail.length; i++) {
            bodyFormData.append('ToEmail[]', ToEmail[i]);
        }
        bodyFormData.append("SenderPassword", SenderPassword);
        bodyFormData.append("EMailBody", EMailBody);
        bodyFormData.append("Subject", Subject);

        fetchData("MessageCenter/MailSend", bodyFormData);
        /* emailjs.sendForm('service_ehyqain', 'template_3bur8zg', e.target, 'user_JABO21I8Gm6sxByJH17Nu')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
            e.target.reset() */
    }

    // const EmailData = () => {
    //     var bodyFormData = new FormData();
    //     fetchEmailData("MessageCenter/ComboData", bodyFormData);
    // }

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };




    const onSubmit = values => {
        console.log(values)
        console.log(DtlsData)
        // debugger;
        // 4/feb change
        var EmailList = "";
        var Email = "";
        // if (props.EmailCount > 0) {
        var bodyFormData = new FormData();
        bodyFormData.append("FromEmail", FromEmail);
        // bodyFormData.append("ToEmail", ToEmail);
        for (var i = 0; i < ToEmail.length; i++) {
            EmailList += " '" + ToEmail[i]["title"] + "',"
        }
        Email = (EmailList.substring(0, EmailList.length - 1));
        bodyFormData.append('ToEmail[]', Email);
        bodyFormData.append("SenderPassword", SenderPassword);
        bodyFormData.append("Subject", Subject);
        bodyFormData.append("EMailBody", EMailBody);
        // bodyFormData.append("AttachmentPath", FileName);
        for (var i = 0; i < AttachmentPath.length; i++) {
            bodyFormData.append('Attachments[]', AttachmentPath[i]);
        }
        fetchData("MessageCenter/MailSend", bodyFormData);
        //        // 4/feb change
        // }
        // else {
        //     alert('Please Select at Least One.')
        // }
    }

    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);

    const handleUploadClick = (event) => {
        try {
            // debugger;
            var path = document.getElementById('icon-button-file').value;
            console.log(path);
            var file = event.target.files[0];
            var AttchFileName = event.target.files[0].name;
            Attchments.push(AttchFileName);
            if (Attchments.length > 0) {
                setAttachmentPath(Attchments);
            }
            setFileName(event.target.files[0].name);
            console.log(file);
            var FName = file.name.split(".")[0];
            setFileAttName(FName);
            var FileExtension = file.name.split(".")[1];
            var Base64 = null;
            const reader = new FileReader();
            var url = reader.readAsDataURL(file);
            console.log(url)
            reader.onloadend = function (e) {
                setSelectedFile([reader.result]);
                Base64 = [reader.result];
                FileExt = FileExtension;
                Base64String = Base64;
                onUploadFile(FName, file);
            };
        }
        catch (error) {
            console.log(error);
        }
    };




    // useEffect(() => {
    //    // debugger;
    //     if (responseEmail['cmbEmail'] !== undefined && responseEmail['cmbEmail'].length > 0) {
    //         setEmailOptions(responseEmail['cmbEmail']);
    //     }
    // }, [responseEmail['cmbEmail']]);


    // const onACCChange = (event, newValue) => {
    //     setAccountName(newValue);
    //     setAccountID(newValue.id);
    // }

    const onUploadFile = (FName) => {
        try {
            // debugger;
            var bodyFormData = new FormData();
            //bodyFormData.append("Type", FileType);
            bodyFormData.append("Group", "EmailAttachment");
            bodyFormData.append("FileName", FName);
            bodyFormData.append("FileExtension", FileExt);
            bodyFormData.append("FileString", Base64String[0].split(",")[1]);
            //bodyFormData.append("RefDocumentID", props.RefDocumentID);
            fetchUploadData("MessageCenter/AddAttachment", bodyFormData);
        }
        catch (error) {
            console.log(error);
        }
    };

    const EmailTemplateData = (options) => {
        if (options !== undefined) {
            let TemplateName = options.map((data) => (
                <option key={data.TemplateName} value={data.EmailTemplateID}>
                    {data.TemplateName}
                </option>
            ));
            setTemplateNamecmb(TemplateName);
        }
    };

    const TemplateData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", '');
        fetchComboData("MessageCenter/ComboData", bodyFormData);
    };

    const TemplateDtlsData = (TempID) => {
        var bodyFormData = new FormData();
        bodyFormData.append("EmailTemplateID", TempID);
        fetchTempData("MessageCenter/GetEmailTemplateDtls", bodyFormData);
    };

    const onSelectChange = (e) => {
        setTemplateID(e.target.value);
        // debugger;
        TemplateDtlsData(e.target.value);
        //var MailBody = '<h1>Hello Namrata</h1>';
        //setEMailBody(EMailBody + MailBody);
    };

    useEffect(() => {
        // debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["EmailTemplate"] !== undefined) {
                EmailTemplateData(ComboDataResponse["EmailTemplate"]);
                setEmailCmb(ComboDataResponse["EmailAuto"]);
            }
        }
    }, [ComboDataResponse]);

    useEffect(() => {
        if (response.Response === true) {
            alert('Send Succesfully')
            props.setMailOpen(false);
        }
        else if (response.Response === false) {
            alert('Failed')
        }
    }, [response]);

    useEffect(() => {
        if (responseTempData !== undefined) {
            if (responseTempData.length > 0) {
                var EmailBody = responseTempData[0].EmailBody
                setEMailBody(EMailBody + EmailBody);
            }
        }
    }, [responseTempData]);

    useEffect(() => {
        // debugger;
        TemplateData();
        // EmailData();
        //console.log(props);
        //console.log(sessionStorage.EmailPassword);
    }, []);

    return <div>
        <Formik initialValues={{ FromEmail: FromEmail, Subject: Subject, EMailBody: EMailBody, TemplateID: TemplateID }}
            validationSchema={validationSchema}
            //onSubmit={sendEmail}
            onSubmit={onSubmit}
            enableReinitialize>
            {formik => {
                return <Form>
                    <Grid item xs={12} container direction="row">
                        <Grid item xs={2}>
                            <label htmlFor={"FromEmail"}
                                style={{
                                    display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                }}>
                                {"From Email"}
                            </label>
                        </Grid>
                        <Grid item xs={10}>
                            <BiztranControlsFormik
                                control='input'
                                type='text'
                                name='FromEmail'
                                disabled={true}
                                onChange={(e) => setFromMail(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    {/* <Grid item xs={12} container direction="row">
                        <Grid item xs={2}>
                            <label htmlFor={"ToEmail"}
                                style={{
                                    display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                }}>
                                {"To Email"}
                            </label>
                        </Grid>
                        <Grid item xs={10} style={{ marginTop: 8 }}>
                            <BiztranControlsFormik
                                control='input'
                                type='text'
                                name='ToEmail'
                                onChange={(e) => setToEmail(e.target.value)}
                            />
                        </Grid>
                    </Grid> */}
                    <Grid item xs={12} container direction="row">
                        <Grid item xs={2} >
                            <label htmlFor={"ToEmail"}
                                style={{
                                    display: 'block', marginLeft: 7, marginTop: 10
                                }}>
                                {"To Email"}
                            </label>
                        </Grid>
                        {/* <Grid item xs={10}>
                            <BiztranControls.Autocomplete
                                options={EmailOption}
                                style={{ marginTop: -10, width: "740px" }}
                                onChange={onACCChange}
                                value={ToEmail}>
                            </BiztranControls.Autocomplete>
                        </Grid>  */}
                        <Grid item xs={10} style={{ marginTop: 10, marginLeft: -10 }}>
                            <BiztranControls.MultiselectAutocomplete
                                // label="ToEmail"
                                style={{ display: 'inline-block' }}
                                options={EmailCmb}
                                value={props.EmailData}
                                onChange={(event, value) => setToEmail(value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row">
                        <Grid item xs={2}>
                            <label htmlFor={"TemplateID"}
                                style={{
                                    display: 'block', width: '100%', marginLeft: 7, marginTop: 8
                                }}>
                                {"Template"}
                            </label>
                        </Grid>
                        <Grid item xs={10} style={{ marginTop: 8 }}>
                            <BiztranControlsFormik
                                control='select'
                                name='TemplateID'
                                options={TemplateNamecmb}
                                onChange={onSelectChange}
                            //onChange={e => setTemplateID(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row">
                        <Grid item xs={2}>
                            <label htmlFor={"Subject"}
                                style={{
                                    display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                }}>
                                {"Subject"}
                            </label>
                        </Grid>
                        <Grid item xs={10} style={{ marginTop: 8 }}>
                            <BiztranControlsFormik
                                autoFocus="autofocus"
                                control='input'
                                type='text'
                                name='Subject'
                                //disabled={true}
                                ref={ref}
                                value={Subject}
                                onChange={(e) => {
                                    setSubject(e.target.value)
                                    handleChange()
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row">
                        {/* <Grid item xs={2}>
                            <label htmlFor={"EMailBody"}
                                style={{
                                    display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                }}>
                                {"Email Body"}
                            </label>
                        </Grid> */}
                        <Grid item xs={12} style={{ marginTop: 8 }}>
                            {/* <BiztranControlsFormik
                                control='textarea'
                                type='text'
                                name='EMailBody'
                                style={{ height: 200, width: 457 }}
                                onChange={(e) => setEMailBody(e.target.value)}
                            /> */}
                            {/*  <Paper style={{border: '1px solid black'}}>
                            <Card>
                                <CardContent>
                                    <BiztranControlsFormik
                                        control='textarea'
                                        type='text'
                                        name='EMailBody'
                                        style={{ height: 200, width: '100%', border:'none', outline:'none' }}
                                        onChange={(e) => setEMailBody(e.target.value)}
                                    />
                                </CardContent>
                                <CardActionArea>
                                    {AttachmentPath.map((item)=>       
                                        <Typography variant="body2" color="text.secondary">{item}</Typography>
                                    )}
                                </CardActionArea>
                            </Card>
                            </Paper> */}
                            <TextEditor
                                setDtlsData={setDtlsData}
                                EMailBody={EMailBody}
                                setEMailBody={setEMailBody}
                            />
                            <Typography>
                                {AttachmentPath.map((item) =>
                                    <Typography variant="body2" color="text.secondary">{item}</Typography>
                                )}
                                <h5 style={{ fontWeight: 'bold', float: 'right' }}>{(ToEmail.length).toString() + " " + "Contacts Selected"}</h5>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction="row"></Grid>
                    <Grid item xs={10} style={{ marginTop: 8, marginLeft: 20 }}>
                        <BiztranControls.Button
                            text="Send"
                            type="submit"
                        //startIcon={<SearchIcon />}
                        // onClick={() => {
                        //     PopulateData();
                        // }}
                        />
                        {/* <BiztranControls.Button
                            text="Attach File"
                            //type="submit"

                            startIcon={<AttachFileIcon />}
                        // onClick={() => {
                        //     PopulateData();
                        // }}
                        /> */}
                        <label htmlFor="icon-button-file">
                            <input
                                id="icon-button-file"
                                type="file"
                                style={{ display: "none" }}
                                ref={hiddenFileInput}
                                onChange={handleUploadClick}
                            />
                            <Tooltip title="Add Attachement">
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"
                                //onClick={onUploadFile}
                                >
                                    <AttachFileIcon />
                                </IconButton>
                            </Tooltip>
                            <BiztranControls.Button
                                text="CLOSE"
                                startIcon={<CloseIcon />}
                                onClick={() => {
                                    props.setMailOpen(false);
                                }}
                            />
                        </label>
                    </Grid>
                </Form>
            }}
        </Formik>

    </div>
};

export default SendEmail;